export {};
//# sourceMappingURL=interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@awesome-cordova-plugins/core/decorators/interfaces.js
// module id = 970
// module chunks = 216